<template>
  <div class="panel" data-qid="project-contributors">
    <header class="panel__header">
      <div class="profile-compact">
        <div class="logo-container">
          <font-awesome-icon icon="user-cog" class="icon-svg--sm"/>
        </div>
        <div class="profile-compact__info">
          <div class="profile-compact__top">
            <div class="profile-compact__text">
              {{ $t('projects.view.manage_contributors_title') }}
              <span class="section-compact__secondary"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="profile-compact__actions">
        <span class="icon-btn"
              data-qid="add-contributor-button"
              v-if="canManage"
              v-b-tooltip.hover
              :title="$t('projects.view.add_contributor')"
              @click="$emit('add')"
        >
          <font-awesome-icon icon="plus"/>
        </span>
      </div>
    </header>

    <div class="panel__body">
      <div v-if="project.users && project.users.length" class="card-list" data-qid="activity-users-list">
        <div class="card-row"
             v-for="(user, user_index) in project.users"
             :key="'contributor-card-' + user_index"
             :id="'contributors-row-' + user_index"
        >
          <div class="card-row__main">
            <div class="card-row__title">
              <span class="text-truncate">
                <Avatar :object="user" size="xs" class="mr-2"></Avatar>
                {{ user.name }}
              </span>

              <span v-if="project.include_independence_declaration" class="card-row__meta">
                <span class="due-pill" :class="'independence-' + independenceKey(user)">
                  <font-awesome-icon :icon="independenceIcon(user)" class="mr-1" />
                  <span>{{ $t('projects.view.independence.status.' + independenceKey(user)) }}</span>
                </span>
              </span>
            </div>
          </div>

          <!-- Inline icon-only actions -->
          <div class="profile-compact__actions">
            <b-button
                v-if="canManage"
                variant="link"
                class="icon-btn unlink-btn"
                qid="unlink-contributor-button"
                v-b-tooltip.hover
                :title="$t('projects.view.unlink_contributor')"
                @click.stop.prevent="$emit('unlink', user)"
            >
              <font-awesome-icon icon="link" class="unlink-btn__idle" />
              <font-awesome-icon icon="unlink" class="unlink-btn__hover" />
            </b-button>
          </div>
        </div>
      </div>
      <div v-else class="section-container">
        <span class="text-muted">
          {{ $t('system.missing_input') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

// Contributors of a project that isn't an engagement, with their independence declaration
export default {
  name: 'ProjectContributors',
  props: {
    project: {
      type: Object,
      required: true
    },
    canManage: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Avatar
  },
  methods: {
    independenceKey(user) {
      const value = this.project.users_independence ? this.project.users_independence[user.id] : null;
      if (value === 1) {
        return 'approved';
      }
      if (value === 2) {
        return 'rejected';
      }
      return 'pending';
    },
    independenceIcon(user) {
      const icons = { approved: 'check-circle', rejected: 'times-circle', pending: 'exclamation-triangle' };
      return icons[this.independenceKey(user)];
    }
  }
}
</script>
